import React from "react";
import MastersCards from "../component/MastersCards"; 
import { User, Ruler, Palette, Building2,Shirt, Layers  } from "lucide-react";
import CreateDesignPage from "./CreateDesignPage";

import { useUserStore } from "../store/AuthUserStore";

// Define an interface for the shape of each card object
interface CardData {
  title: string;
  icon: React.ReactNode;
  bgColor: string;
  path: string;
  permission?: boolean;
}

const Masters: React.FC = () => {


    const user = useUserStore((state) => state.user);
  const permissions = user?.permissions || {
    designMaster: false,
    sizeMaster: false,
    vendorMaster: false,
    fabricMaster: false, 
    astarMaster: false,
  };

  const cardsData: CardData[] = [
    {
      title: "Design Master",
      icon: <Palette size={32} className="text-pink-500" />,
      bgColor: "bg-pink-200",
      path: "/designmaster",
       permission: permissions.designMaster,
    },
    {
      title: "Size Master",
      icon: <Ruler size={32} className="text-blue-500" />,
      bgColor: "bg-blue-200",
      path: "/sizemaster",
      permission: permissions.sizeMaster,

    },
    {
      title: "Vendor Master",
      icon: <Building2 size={32} className="text-green-500" />,
      bgColor: "bg-green-200",
      path: "/vendormaster",
      permission: permissions.vendorMaster,
    },
     {
      title: "Fabric Type Master",
      icon: <Shirt size={32} className="text-yellow-500" />,
      bgColor: "bg-yellow-200",
      path: "/fabric-type-master",
      permission: permissions.fabricMaster,
    },
   
    {
      title: "Astar Master",
      icon: <Layers size={32} className="text-purple-500" />,
      bgColor: "bg-purple-200",
      path: "/astar-master",
      permission: permissions.astarMaster,
    },
  ];

  return (
    <div className="pl-2">
      <div className="mb-1">
        <h1 className="text-3xl font-bold text-gray-800 ">Database Master</h1>
        <p className="text-gray-500 mt-2 font-medium">
          Manage all master data configurations
        </p>
      </div>
      <div className="max-w-5xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {cardsData
            .filter((card) => card.permission) 
            .map((card, index) => (
              <MastersCards
                key={index}
                title={card.title}
                icon={card.icon}
                bgColor={card.bgColor}
                to={card.path}
              />
            ))}

        </div>
      </div>
    </div>
  );
};

export default Masters;
